// extracted by mini-css-extract-plugin
module.exports = {"sliderBase":"styles_sliderBase__1FBtF","slider":"styles_slider__1wYbb","sliding":"styles_sliding__277CX"};